import React from 'react';
import { Box, Typography } from '@mui/material';

const ClientEngagementTrendsClients = () => {
  return (
    <Box
      sx={{
        background: 'rgba(255, 255, 255, 1)',
        padding: '20px',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        width: '95%',
        height: '100%',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        margin: '10px',
        opacity: 0.5,
        marginBottom: '0%',
      }}
    >
      <Typography
        sx={{
          fontSize: '1.4rem',
          color: 'black',
          fontWeight: 'bold',
          marginBottom: '20px',
          marginRight: '40px',
        }}
      >
        Client Engagement Trends
      </Typography>

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '95%',
          height: '95%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.7)',
          zIndex: 10,
          borderRadius: '12px',
        }}
      >
        <Typography
          variant="h3"
          fontWeight="bold"
          color="rgb(0, 0, 0)"
          sx={{
            fontSize: '40px',
            fontFamily: 'Albert Sans, sans-serif',
            opacity: 1,
          }}
        >
          Coming Soon...
        </Typography>
      </Box>

      <img 
        src="/clientTrends.png" 
        alt="clientTrends" 
        style={{
          maxWidth: '100%',
          height: '80%',
          borderRadius: '8px',
          marginRight: '0px',
        }} 
      />
    </Box>
  );
};

export default ClientEngagementTrendsClients;